import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

export type ButtonSize = 'lg' | 'md' | 'sm';
export type ButtonVariant = 'filled' | 'outlined' | 'outlined-error';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'invd-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  public size = input<ButtonSize>('md');

  public variant = input<ButtonVariant>('filled');

  public disabled = input(false);

  protected classNames = computed(() => ({
    button: true,
    'button-lg': this.size() === 'lg',
    'button-md': this.size() === 'md',
    'button-sm': this.size() === 'sm',
    'button-filled': this.variant() === 'filled',
    'button-outlined': this.variant() === 'outlined',
    'button-outlined-error': this.variant() === 'outlined-error',
    'button-disabled': this.disabled() === true,
  }));
}
